import { createRouter, createWebHistory } from 'vue-router'
import api from '../api'
import Home from '../views/Home.vue'
import Market from '../views/Market.vue'
import Tools from '../views/Tools.vue'
import Prompts from '../views/Prompts.vue'
import Agents from '../views/Agents.vue'
import About from '../views/About.vue'
import MarketDetail from '../views/MarketDetail.vue'
import ToolDetail from '../views/ToolDetail.vue'
import NewsDetail from '../views/NewsDetail.vue'
import AdminLogin from '../views/admin/Login.vue'
import AdminLayout from '../layouts/AdminLayout.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import MarketManagement from '../components/admin/MarketManagement.vue'
import ToolsManagement from '../components/admin/ToolsManagement.vue'
import NewsManagement from '../components/admin/NewsManagement.vue'
import AboutManagement from '../components/admin/AboutManagement.vue'
import FooterManagement from '../components/admin/FooterManagement.vue'
import CategoryManagement from '../components/admin/CategoryManagement.vue'
import TagManagement from '../components/admin/TagManagement.vue'
import PromptManagement from '../components/admin/PromptManagement.vue'
import AgentManagement from '../components/admin/AgentManagement.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'MKCases - AI工具与资源聚合平台',
      description: 'MKCases 是一个专业的AI工具与资源聚合平台，提供最新的AI工具、提示词、智能体示例和市场资源，帮助您快速找到最适合的AI解决方案。',
      keywords: 'AI工具,人工智能,提示词,智能体,AI资源,AI市场,AI工具推荐,AI发展状况,开源项目',
      noindex: false
    }
  },
  {
    path: '/market',
    name: 'Market',
    component: Market,
    meta: {
      title: '第三方市场 - MKCases',
      description: '发现最新的AI应用和第三方工具，包括应用、插件、模板等各类AI资源，帮助您快速找到最适合的AI解决方案。',
      keywords: 'AI应用,AI插件,AI模板,第三方工具,AI市场,AI资源',
      noindex: false
    }
  },
  {
    path: '/market/:id',
    name: 'MarketDetail',
    component: MarketDetail,
    meta: {
      title: '资源详情 - MKCases',
      description: '查看AI资源的详细信息，包括功能介绍、使用说明、下载链接等。',
      keywords: 'AI资源详情,AI工具详情,AI应用详情',
      noindex: false
    }
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools,
    meta: {
      title: 'AI工具雷达 - MKCases',
      description: '探索最新的AI工具和开发资源，包括AI发展状况、优秀开源项目、好用的第三方工具等，帮助您了解AI技术的最新动态。',
      keywords: 'AI工具,AI发展,开源项目,第三方工具,AI技术,AI开发',
      noindex: false
    }
  },
  {
    path: '/tools/:id',
    name: 'ToolDetail',
    component: ToolDetail,
    meta: {
      title: '工具详情 - MKCases',
      description: '查看AI工具的详细信息，包括功能介绍、使用说明、相关资源等。',
      keywords: 'AI工具详情,工具介绍,AI开发工具',
      noindex: false
    }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: {
      title: '新闻详情 - MKCases',
      description: '查看AI相关新闻的详细内容，了解AI技术的最新动态和发展趋势。',
      keywords: 'AI新闻,AI动态,AI资讯,人工智能新闻',
      noindex: false
    }
  },
  {
    path: '/prompts',
    name: 'Prompts',
    component: Prompts,
    meta: {
      title: '常用提示词 - MKCases',
      description: '精选的AI提示词模板库，涵盖各种场景和用途，帮助您更好地使用AI工具，提高工作效率。',
      keywords: '提示词,Prompt,AI提示词,提示词模板,AI使用技巧',
      noindex: false
    }
  },
  {
    path: '/agents',
    name: 'Agents',
    component: Agents,
    meta: {
      title: '智能体示例 - MKCases',
      description: '体验各种AI智能体示例，包括客服助手、创作工具、分析工具等，了解AI智能体的实际应用场景。',
      keywords: '智能体,AI智能体,AI助手,AI Agent,智能体示例',
      noindex: false
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们 - MKCases',
      description: '了解MKCases平台的使命、愿景和团队信息，我们致力于为AI开发者和用户提供最好的资源聚合服务。',
      keywords: '关于MKCases,平台介绍,团队信息',
      noindex: false
    }
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: {
      title: '管理员登录 - MKCases',
      description: 'MKCases 管理后台登录页面',
      noindex: true
    }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { 
      requiresAuth: true,
      title: '管理后台 - MKCases',
      description: 'MKCases 管理后台',
      noindex: true
    },
    redirect: { name: 'AdminDashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: {
          title: '管理后台 - 仪表盘',
          noindex: true
        }
      },
      {
        path: 'market',
        name: 'AdminMarket',
        component: MarketManagement,
        meta: {
          title: '管理后台 - 市场资源',
          noindex: true
        }
      },
      {
        path: 'tools',
        name: 'AdminTools',
        component: ToolsManagement,
        meta: {
          title: '管理后台 - 工具管理',
          noindex: true
        }
      },
      {
        path: 'news',
        name: 'AdminNews',
        component: NewsManagement,
        meta: {
          title: '管理后台 - 新闻管理',
          noindex: true
        }
      },
      {
        path: 'about',
        name: 'AdminAbout',
        component: AboutManagement,
        meta: {
          title: '管理后台 - 关于管理',
          noindex: true
        }
      },
      {
        path: 'footer',
        name: 'AdminFooter',
        component: FooterManagement,
        meta: {
          title: '管理后台 - 页脚管理',
          noindex: true
        }
      },
      {
        path: 'categories',
        name: 'AdminCategories',
        component: CategoryManagement,
        meta: {
          title: '管理后台 - 分类管理',
          noindex: true
        }
      },
      {
        path: 'tags',
        name: 'AdminTags',
        component: TagManagement,
        meta: {
          title: '管理后台 - 标签管理',
          noindex: true
        }
      },
      {
        path: 'prompts',
        name: 'AdminPrompts',
        component: PromptManagement,
        meta: {
          title: '管理后台 - 提示词管理',
          noindex: true
        }
      },
      {
        path: 'agents',
        name: 'AdminAgents',
        component: AgentManagement,
        meta: {
          title: '管理后台 - 智能体管理',
          noindex: true
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  // 如果访问登录页且已登录，验证 token 后跳转到管理后台
  if (to.path === '/admin/login' && token) {
    try {
      const response = await api.post('/admin/auth/verify/')
      if (response.data.valid) {
        next('/admin')
        return
      } else {
        localStorage.removeItem('admin_token')
      }
    } catch (error) {
      localStorage.removeItem('admin_token')
    }
  }
  
  // 如果需要认证但未登录，跳转到登录页
  if (to.meta.requiresAuth) {
    if (!token) {
      next('/admin/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

// 路由后置守卫：更新 SEO meta 信息
router.afterEach((to) => {
  // 动态更新页面标题和 meta 信息
  const meta = to.meta || {}
  const title = meta.title || 'MKCases - AI工具与资源聚合平台'
  const description = meta.description || 'MKCases 是一个专业的AI工具与资源聚合平台'
  const keywords = meta.keywords || 'AI工具,人工智能,提示词,智能体'
  const noindex = meta.noindex || false
  
  // 更新 document title
  document.title = title
  
  // 更新 meta 标签
  const updateMetaTag = (name, content, attribute = 'name') => {
    let tag = document.querySelector(`meta[${attribute}="${name}"]`)
    if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute(attribute, name)
      document.head.appendChild(tag)
    }
    tag.setAttribute('content', content)
  }
  
  const updateLinkTag = (rel, href) => {
    let tag = document.querySelector(`link[rel="${rel}"]`)
    if (!tag) {
      tag = document.createElement('link')
      tag.setAttribute('rel', rel)
      document.head.appendChild(tag)
    }
    tag.setAttribute('href', href)
  }
  
  // 更新基础 meta 标签
  updateMetaTag('description', description)
  updateMetaTag('keywords', keywords)
  
  // Open Graph tags
  const baseUrl = window.location.origin + to.fullPath
  updateMetaTag('og:title', title, 'property')
  updateMetaTag('og:description', description, 'property')
  updateMetaTag('og:type', 'website', 'property')
  updateMetaTag('og:url', baseUrl, 'property')
  
  // Twitter Card tags
  updateMetaTag('twitter:card', 'summary_large_image')
  updateMetaTag('twitter:title', title)
  updateMetaTag('twitter:description', description)
  
  // Robots meta
  if (noindex) {
    updateMetaTag('robots', 'noindex, nofollow')
  } else {
    updateMetaTag('robots', 'index, follow')
  }
  
  // Canonical URL
  updateLinkTag('canonical', baseUrl)
})

export default router

